import { useState, useEffect } from 'react';

class LocalAppSettings{
  static _prefKeyLocale = 'locale';
  static _prefKeyUseRelativeDateTime = 'use_relative_date_time';
  static _prefKeyPreferSatelliteMapView = 'prefer_satellite_map_view';
  static _prefKeyLargeText = 'large_text';
  static _prefKeySoundsOn = 'sounds_on';
  static _prefDevMode = 'dev_mode';
  static _requestFeedFilter = 'request_feed_filter';
  static _currentCountryCode = 'current_country_code';

  static globalLang = 'en'; // Default language

  static loadSettings() {
    const localAppSettings = {};

    localAppSettings.locale = localStorage.getItem(this._prefKeyLocale) || 'en';
    this.globalLang = localAppSettings.locale;

    localAppSettings.devMode = localStorage.getItem(this._prefDevMode) === 'true';
    localAppSettings.useRelativeDateTime = localStorage.getItem(this._prefKeyUseRelativeDateTime) === 'true';
    localAppSettings.preferSatelliteMapView = localStorage.getItem(this._prefKeyPreferSatelliteMapView) === 'true';
    localAppSettings.largeText = localStorage.getItem(this._prefKeyLargeText) === 'true';
    localAppSettings.soundsOn = localStorage.getItem(this._prefKeySoundsOn) === 'true';
    localAppSettings.currentCountryCode = localStorage.getItem(this._currentCountryCode) || 'ae';

    localAppSettings.requestFeedFilter = parseInt(localStorage.getItem(this._requestFeedFilter)) || 0;

    return localAppSettings;
  }

  static async setCurrentCountryCode(countryCode) {
    localStorage.setItem(this._currentCountryCode, countryCode);
  }

  static async setDevModeAs(newIsDevValue) {
    localStorage.setItem(this._prefDevMode, newIsDevValue.toString());
  }

  static async setLocaleAs(newLocaleValue) {
    if (newLocaleValue !== 'en' && newLocaleValue !== 'ar') return;
    localStorage.setItem(this._prefKeyLocale, newLocaleValue);
  }

  static async setPreferMapView(preferSatellite) {
    localStorage.setItem(this._prefKeyPreferSatelliteMapView, preferSatellite.toString());
  }

  static async setUseOfRelativeDateTime(use) {
    localStorage.setItem(this._prefKeyUseRelativeDateTime, use.toString());
  }

  static async setCurrentCountryCode(countryCode) {
    localStorage.setItem(this._currentCountryCode, countryCode);
  }

  static async setLargeText(large) {
    localStorage.setItem(this._prefKeyLargeText, large.toString());
  }

  static async setSoundsOn(on) {
    localStorage.setItem(this._prefKeySoundsOn, on.toString());
  }

  static async setRequestFeedFilter(mode) {
    localStorage.setItem(this._requestFeedFilter, mode.toString());
  }
}

export default LocalAppSettings;
